module.exports = __webpack_public_path__ + "img/active_step.0140c00c.svg";